import { createJsxLink } from "src/utils/create-jsx-link";

export const BUYER_HOW_IT_WORKS = [
  {
    title: 'Step 1: Select "Browse Listings"',
  },
  {
    title:
      "Step 2: Log in with the email address associated with your Iowa State Student Ticket Account. Logging in with another email address will not give you access to the marketplace.",
  },
  {
    title: "Step 3: Select the game you are interested in attending.",
  },
  {
    title:
      "Step 4: Select a listing you wish to purchase. Please note you are purchasing an actual student seat location and must sit in the seat that you purchase on gameday.",
  },
  {
    title: "Step 5: Complete the purchase of your ticket.",
  },
  {
    description: (
      <>
        Tickets will be available to manage after your purchase. You will be
        notified via text message with a link to your account manager to access
        tickets.
        <br />
        <br />
        All sales are final. No refunds will be issued.
      </>
    ),
  },
];

export const SELLER_HOW_IT_WORKS = [
  {
    title: 'Step 1: Select "Sell your Ticket"',
  },
  {
    title:
      "Step 2: Log in with the email address associated with your Iowa State Student Ticket Account. Logging in with another email address will not give you access to the marketplace.",
  },
  {
    title: "Step 3: Select the game you wish to sell.",
  },
  {
    title: "Step 4: Complete the Seller Onboarding process.",
  },
  {
    title: "Step 5: Enter the number of tickets you wish to list.",
  },
  {
    title: (
      <>
        Step 6: Set your listing price for the tickets and click &quot;List for
        Resale&quot;.
        <br />
        <br />
      </>
    ),
  },

  {
    title: "Congrats! Your listing is complete",
    description: (
      <>
        If your ticket is purchased, you will be notified via text. Check back
        in on the portal at any time to view or update the status of your
        listing.
        <br />
        <br />
        If plans change and you can attend the game, be sure to remove your
        listing from the marketplace. If your ticket is purchased, no refunds
        will be issued.
        <br />
        <br />
        Please wait 5 business days for payouts to reflect in your bank
        statement prior to reaching out to support by clicking on Chat with
        Support in the right hand hamburger menu.
        <br />
        <br />
        All sales are final.
        <br />
        <br />
        Unsold tickets are removed from the Marketplace and tickets that do not
        sell remain valid for the seller to use on game day.
      </>
    ),
  },
];

export function MARKETPLACE_FAQS(teamSchema: string) {
  return [
    {
      question: "What is the Student Marketplace?",
      answer: (
        <>
          The Student Marketplace is the{" "}
          <b>only official, university-approved</b> platform for Iowa State
          students to securely <b> buy and sell student football tickets</b>. It
          ensures that tickets stay within the student community and helps
          protect your ticket privileges.
        </>
      ),
    },
    {
      question: "Who can use the Student Marketplace?",
      answer: (
        <>
          Only <b>Iowa State University students</b> can access the platform
          using the email associated with your Iowa State Student Ticket
          Account.
        </>
      ),
    },
    {
      question: "Can I sell my student ticket elsewhere?",
      answer: (
        <>
          No. Selling your student ticket on any other platform is not allowed
          and may result in the <b>loss of your student ticket</b>.
        </>
      ),
    },
    {
      question: "When can I list my ticket?",
      answer: (
        <>
          Listings can be created at any time,{" "}
          <b>
            but listings for each game will close two hours after kickoff on
            game day and all sales must be finalized by then.
          </b>
        </>
      ),
    },
    {
      question: "What if I change my mind after listing my ticket?",
      answer: (
        <>
          You can remove your ticket from the Marketplace at any time{" "}
          <b>before it is purchased</b>. If your ticket is purchased, the sale
          is <b>final</b> and <b>cannot be reversed or refunded</b>, even if
          your plans change.
        </>
      ),
    },
    {
      question: "When will I receive my ticket(s)?",
      answer: (
        <>
          Your Iowa State University student ticket will be delivered within 2
          hours of purchase in your Iowa State Account Manager.
        </>
      ),
    },
    {
      question: "When will I receive my payout?",
      answer: (
        <>
          If your ticket is sold, your payout is triggered immediately, but
          please allow 5 business days for it to reflect on your bank statement.
        </>
      ),
    },
    {
      question: "Can I sit with friends if I buy a ticket?",
      answer: (
        <>
          You are purchasing an actual student seat location and{" "}
          <b>must sit in the seat you purchase on gameday</b>.
        </>
      ),
    },
    {
      question: "Are refunds available?",
      answer: (
        <>
          No. <b>All sales are final</b> for both buyers and sellers. Please
          make sure of your plans before buying or listing a ticket.
        </>
      ),
    },
    {
      question: "How do I contact support?",
      answer: (
        <>
          If you need help, click on <b>Chat with Support</b> in the menu icon
          (three line logo) at the top-right corner.
          <br />
          <br />
          Support is available{" "}
          <b>Monday through Friday, 9:00 AM to 5:00 PM CST</b>, and during
          <b>gamedays</b> to assist with urgent questions.
        </>
      ),
    },
  ];
}

export const ListingCheckoutTermsAndCondition = () => {
  return (
    <>
      By checking this box you have read and agree to Attend’s{" "}
      {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")},{" "}
      {createJsxLink(
        "Privacy Policy",
        "https://www.attend.tech/privacy-policy"
      )}{" "}
      and{" "}
      {createJsxLink(
        "Purchase Policy",
        "http://attend.tech/marketplace-purchase-policy"
      )}
      .
    </>
  );
};

export const CreateListingTermsAndCondition = () => {
  return (
    <>
      By clicking “Create Listing”, you have read and agree to Attend’s{" "}
      {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")},{" "}
      {createJsxLink(
        "Privacy Policy",
        "https://www.attend.tech/privacy-policy"
      )}{" "}
      and{" "}
      {createJsxLink(
        "Purchase Policy",
        "http://attend.tech/marketplace-purchase-policy"
      )}
      .
    </>
  );
};
